<template>
	<div id="appbox">
		<div class="top_heard">
			<div class="top_box">
				<div class="logo_box" @click="gohome()">
					<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;" height=""
						srcset="">
				</div>
				
				<div class="top_search_box">
					<!-- 	<div class="top_search">
						<el-select v-model="top_search_url" size="small" class="top_search_type" placeholder="搜索类型">
						  <el-option
						    v-for="item in options"
						    :key="item.value"
						    :label="item.label"
						    :value="item.value">
						  </el-option>
						</el-select>
						<input type="text" autocomplete="off" placeholder="搜索关键词……" class="el-input__inner"  style="border: 0px;width: 200px;height: 30px;">
						<img class="top_search_icon" src="../../../static/img/顶部搜素图标.png" alt="" srcset="">
					</div>
					  -->
				</div>
				
			</div>
			<div class="top_tab_box">
				<div class="toptabnav">
					<el-menu :default-active="activeIndex2" class="el-menu-demo" mode="horizontal"
						@select="handleSelect" router background-color="#FE7C2B" text-color="#FFFFFF"
						active-text-color="#FFFFFF">
						<el-menu-item index="/Home">首页</el-menu-item>
						<el-menu-item index="/Newslist">研学资讯</el-menu-item>
						<el-menu-item index="/Courselist">研学课程</el-menu-item>
						<el-submenu index="/institution">
							<template slot="title">研学机构</template>
							<el-menu-item index="/Camplist">研学营地</el-menu-item>
							<el-menu-item index="/Baselist">研学基地</el-menu-item>
							
						</el-submenu>

						<el-menu-item index="/Campmap">研学地图</el-menu-item>
						<el-menu-item index="/Activitylist">活动中心</el-menu-item>
						<el-menu-item index="/Linelist">研学线路</el-menu-item>
						<el-submenu index="/yanxueteam">
							<template slot="title">研学团队</template>
							<el-menu-item index="/mentorlist">研学导师</el-menu-item>
							<el-menu-item index="/expertlist">专家团队</el-menu-item>
						</el-submenu>
						<!-- <el-menu-item index="/" >研学政策</el-menu-item> -->
					</el-menu>
				</div>
			</div>
		</div>
		<div class="register_box">
			<div class="title">黑龙江省研学旅游 “百线百课” 精品线路及精品课程</div>
			<div class="box_main">
				<div class="box_t">

					<img v-for="(item, index) in imgList" :src="item.icon" alt=""
						@click="handledetail('bxbk'+index, item.name)">
					<!-- <a :href="pdfurl"  target="_blank"  @click="handle(index,item.name)" v-for="(item,index) in imgList"><img :src="item.icon" alt="" @click="handledetail(index,item.name)"></a> -->

				</div>

			</div>
			<div class="enter" @click="handleEnter">申报入口</div>
			<div class="msg">
				<div class="msg_unit" id="msg_imp">
					<div class="title_msg">主办单位:</div>
					<div id="msg_imp">
						黑龙江省文化和旅游厅、黑龙江省教育厅、中共黑龙江省宣传委员部、黑龙江省科技厅、黑龙江省自然资源厅、黑龙江省生态环境厅、黑龙江省农业农村厅、黑龙江省体育局、黑龙江省林业和草原局、共青团黑龙江省委员会、黑龙江省科学技术协会
					</div>
				</div>
				<div class="msg_unit">
					<div class="title_msg2">承办单位:</div>
					<div id="msg_imp">
						海林市教育体育局、黑龙江省生态职业技术学院、哈尔滨市香坊区亿拓科技体育研学有限公司、七台河市农投文化产业有限公司、黑龙江省农垦职业学院、黑龙江飞鹤乳业有限公司、黑龙江旅游职业技术学院、密山市教育局
					</div>
				</div>
				<div class="msg_unit">
					<div class="title_msg3">协办单位:</div>
					<div id="msg_imp">黑龙江省研学实践教育协会、黑龙江省数字经济研学会、黑龙江省旅游协会、黑龙江省导游协会、黑龙江智慧研学云平台</div>
				</div>
			</div>
			<div class="news" @click="handleNews">
				<img src="https://yxwy-1254115215.cos.ap-beijing.myqcloud.com/20240416/5273225c97df9866294abe57cea6400a.jpg"
					alt="">
			</div>
		</div>
		<div :class="tops ? 'navbar' : 'navbar-top'">
			<el-tooltip class="item" effect="dark" content="返回首页" placement="left">
				<a style="display: flex;flex-direction: column;justify-content: center; align-items: center;"
					@click="gohome()"><i class="el-icon-s-home"></i>
					<div style="font-size: 14px;">首页</div>
				</a>
			</el-tooltip>
			<div class="qrShow3 right2" v-if="showofficialQR">
				<img src="../../../static/img/gzhsuncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
			</div>
			
			<div class="qrShow2 right2" v-if="showserviceQR">
				<img src="../../../static/img/客服码.png" style="width: 100px; height: 100px;border-radius: 8px;" />
			</div>
			<a style="display: flex;flex-direction: column;justify-content: center; align-items: center;"
				@mouseover="showserviceQRCode" @mouseleave="hideserviceQRCode"><i class="el-icon-service"></i>

				<div style="font-size: 14px;">客服</div>
			</a>
			<div class="qrShow right" v-if="showQR">
				<img src="../../../static/img/suncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
			</div>
			
			<el-tooltip class="item" effect="dark" content="返回顶部" placement="left" v-if="tops">
				<a @click="gotop"><i class="el-icon-caret-top"></i>
					<br>
					<span>顶部</span></a>
			</el-tooltip>
		</div>
		<div class="pagesbottom_box">
			<div class="subtexts">
				<div v-for="item in bottomnav" :key="item" @click="gobottomnav(item.type, item.linkurl)">{{ item.title
					}}
				</div>

			</div>
			<div class="row">

				<div class="copy-left">
					<div class="bottom_logo">
						<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;" height=""
							srcset="">
					</div>
					

				</div>
				<div class="bottom_right">
					<div class="bottom_msg">
						{{ pcsetdata.foot }}
					</div>
					<div class="bottom_msg">
						<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">{{ ' ' + pcsetdata.icp
							}}</a>
					</div>
					<div class="bottom_msg">
						课程适用人群:学生群体
					</div>
				</div>

			</div>
		</div>
		<el-dialog :visible.sync="dialogFormVisible" :width="'590px'"  custom-class="dialog_border">
			<div class="dia_title">{{dialogtitle}}</div>
			<div class="divi"></div>
			<div v-if="dialogerror" class="dia_height"><i class="el-icon-warning-outline"></i>当前还未上传方案</div>
			<div v-if="dialogtrue"  class="dia_height">
				
				<div v-for="(item,index) in tcpdf" class="div_a">
					<a  :href="item.pdf" target="_blank">{{item.title}}</a>
					<a :href="item.pdf" target="_blank" style="color: gray;font-size:12px">点击查看详情</a>
				</div>
			</div>
			<div  @click="dialogFormVisible = false" class="close">关闭</div>
			<!-- <div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
			</div> -->
		</el-dialog>
	</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { getpdfUrl, getBanner, getWxLogin, getAclist, getNewslist, getCategory, getCamplist, getActivitylist, getPac, getCourselist, getPc, getNt, getTeacher, getAdvbanner, getPlate, getLinelist, yzmsms, register, bindmentor, searchcamp, bindcamp, searchtraveler, bindtraveler, getbottomnav, getodc, getpostlist, getpostlevel, OAregister } from '@/request/api'
import { Loading } from 'element-ui';
// import navTab from '../Navtab/navtab'

export default {
	name: "bxbk",
	// components: {
	//   navTab
	// },
	data() {
		return {
			dialogerror:true,
			dialogtrue:true,
			bottomnav: [],
			dialogtitle: "",
			tcpdf:[],
			pdfurl: "https://yxwy.wanjiaxiao.cn/index/index/tcpdf",
			dialogFormVisible: false,
			imgList: [
				{
					name: "红色研学",
					icon: "https://yxwy-1254115215.cos.ap-beijing.myqcloud.com/20240412/220370f14d57a02e31b6a9e461cdf299.png"
				},
				{
					name: "自然研学",
					icon: "https://yxwy-1254115215.cos.ap-beijing.myqcloud.com/20240412/dfc683d6bdb272dfa1a3392fdd767fbc.png"
				},
				{
					name: "科技研学",
					icon: "https://yxwy-1254115215.cos.ap-beijing.myqcloud.com/20240412/e055bcd02c70becf5abeadbb590ecf6d.png"
				},
				{
					name: "冰雪研学",
					icon: "https://yxwy-1254115215.cos.ap-beijing.myqcloud.com/20240412/8b075fa42832ae2e32c9c0880145a828.png"
				},
				{
					name: "农业研学",
					icon: "https://yxwy-1254115215.cos.ap-beijing.myqcloud.com/20240412/886afd6a0eda8468b40cc3247d5ccb1b.png"
				},
				{
					name: "工业研学",
					icon: "https://yxwy-1254115215.cos.ap-beijing.myqcloud.com/20240412/970c8715ee4c607ddf9109f277cda82e.png"
				},
				{
					name: "非遗研学",
					icon: "https://yxwy-1254115215.cos.ap-beijing.myqcloud.com/20240412/185b34755bc564eeac45c6932053a6f1.png"
				},
				{
					name: "地理研学",
					icon: "https://yxwy-1254115215.cos.ap-beijing.myqcloud.com/20240412/eb3649e0ba8e226ca9c98473dff8b585.png"
				},
				{
					name: "历史研学",
					icon: "https://yxwy-1254115215.cos.ap-beijing.myqcloud.com/20240412/1b309ee2a30317f41ff030d4e554b4da.png"
				},
				{
					name: "边境研学",
					icon: "https://yxwy-1254115215.cos.ap-beijing.myqcloud.com/20240412/b50e329407e027ad05f2f0697bd68396.png"
				},

			],
			activeIndex2: '/register',
			top_search_url: '',
			manage_url: '/',
			manageoptions: [
				{
					value: '/',
					label: '管理入口'
				}, {
					value: 'https://yxwy.wanjiaxiao.cn/',
					label: '机构管理后台'
				},
				{
					value: 'http://xh.wanjiaxiao.cn/seeyon/index.jsp',
					label: '研学OA平台'
				}
			],
			phoneboxshow: false,
			register_searchtype: false,
			stepid: 0,
			register_type: 2,
			agreementchecked: true,
			platelist: [],
			second: 60,
			CD: true,
			ruleForm: {
				mobile: '',
				nickName: '',
				password: '',
				repassword: '',
				unionid: '',
				openid: '',
				captcha: '',
				is_pc: 1,
			},
			OAForm: {
				uname: '',
				gender: {},
				telNumber: '',
				orgDepartmentId: '',
				orgPostId: '',
				orgLevelId: '',
				loginName: '',
				pass: '',
				repass: '',
				unionid: '',
				openid: '',
				captcha: '',
				District: '',
				City: '',
				is_pc: 1,
			},
			department: '',
			genderlist: [
				{
					title: '男',
					id: 1
				}, {
					title: '女',
					id: 2
				}
			],
			orgLevelIdlist: [],
			orgPostIdlist: [],
			departmentoptions: [
				{
					id: '黑龙江',
					title: '黑龙江'
				},
			],
			Cityopiton: [],
			Districtopiton: [],
			campmsg: {},
			dialogImageUrl: '',
			dialogVisible: false,
			rules: {
				mobile: [
					{ required: true, message: '请输入手机号码', trigger: 'blur' },
					{ min: 11, max: 11, message: '长度在11个数字', trigger: 'blur' }
				],
				nickName: [
					{ required: true, message: '请输入账号昵称', trigger: 'blur' },
				],
				password: [
					{ required: true, message: '请设置登录密码', trigger: 'blur' },
				],
				repassword: [
					{ required: true, message: '请确认登录密码', trigger: 'blur' },
				],
				captcha: [
					{ required: true, message: '请确认验证码', trigger: 'blur' },
					{ min: 6, max: 6, message: '验证码位数错误', trigger: 'blur' }
				],

			},
			value: '',
			ranklist: [
				{
					value: 0,
					label: '国家级'
				}, {
					value: 1,
					label: '省级'
				}, {
					value: 2,
					label: '市级'
				}, {
					value: 3,
					label: '县级'
				}
			],
			departmentranks: [
				{
					id: 0,
					title: '省级'
				}, {
					id: 1,
					title: '市级'
				}, {
					id: 2,
					title: '区级'
				}
			],
			departmentrank: '',
			newscategory_id: 0,
			logintype: true,
			banner: [
			],
			newslist: [],
			aclist: [],
			lessonlist: [],
			categorytypes: [],
			linelist: [],
			lessoncategory_id: 0,
			pcsetdata: {},
			ntlist: [],
			mentor: {
				sfzh: '',
				zsbh: '',
			},
			campform: {
				name: '',
				truename: '',
				phone: '',
			},
			travelerdata: {

			},
			mentorlist: [],
			camplist: [],
			campshow: false,
			mentor_index: '',
			mentorindex: 0,
			mentortotal: 0,
			advbanner: [],
			//侧边栏
			showQR: false,
			showserviceQR: false,
			showofficialQR: false,
			tops: false,
			heights: window.innerHeight,
			scrolltop: '',
		}
	},
	beforeCreate() {
		//  const loading = this.$loading({
		// lock: true,
		// text: '页面载入……',
		// // spinner: 'el-icon-loading',
		// background: '#ffffff'
		//  });
	},
	created() {
		this.getpcset()
	},
	mounted() {
		this.getpostlist()
		this.getpostlevel()
		this.getPlate()

		this.getbottomnav()

		// this.getlessonlist()
		window.addEventListener('scroll', this.scrollToTop)

	},
	destroyed() {
		window.removeEventListener('scroll', this.scrollToTop)
	},
	beforeDestroy() {

	},
	methods: {
		handleNews() {
			this.$router.push({
				path: '/Newslist',
				name: "/Newslist",
				query: {
					id: "12"
				}

			});
		},
		handledetail(index, name) {
			console.log(index);
			var data = {
				flag: index
			}

			getpdfUrl(data).then(res => {
				if (res.data.code == 200) {
					console.log("1111222", res.data.data[0]);
					if (res.data.data.length == 1) {
						this.pdfurl = res.data.data[0].pdf
						window.open(this.pdfurl)
					} else if (res.data.data.length == 0) {
						this.dialogerror=true
						this.dialogtrue=false
						this.dialogFormVisible = true
						this.dialogtitle = name
						
					}else {
						this.dialogerror=false
						this.dialogtrue=true
						this.tcpdf=res.data.data
						console.log("5555",this.tcpdf);
						this.dialogFormVisible = true
						this.dialogtitle = name
					}
				} else {


				}

			}).catch(error => {
				console.error(error);
			});

		},
		handleEnter() {
			console.log("注册");
			// this.$router.push({
			// 	path: '/bxbkLogin',
			// 	name: "/bxbkLogin",

			// });
			 this.$router.push({
				path: '/bxbkLogin',
			 	name: "/bxbkLogin",

			 });
		
		},
		manageurl(e) {
			console.log('Site', e)
			if (e != '/') {
				window.open(e)
			}
			this.manage_url = '/'
			// window.location.href = e;

		},
		getpostlevel() {
			var data = {

			}
			getpostlevel(data).then(res => {
				if (res.data.code == 200) {
					this.orgLevelIdlist = res.data.data
				}
			})
		},
		getpostlist() {
			var data = {

			}
			getpostlist(data).then(res => {
				if (res.data.code == 200) {
					this.orgPostIdlist = res.data.data
				}
			})
		},
		getodc(e) {

			var data = {

			}
			if (e == 0) {
				// data={
				// 	id:this.OAForm.City.id,
				// }
				this.OAForm.orgDepartmentId = 0
			}
			if (e == 1) {
				data = {
					id: this.OAForm.City.id,
				}
				this.OAForm.orgDepartmentId = this.OAForm.City.id
			}
			if (e == 2) {
				// data={
				// 	id:this.OAForm.District,
				// }
				this.OAForm.orgDepartmentId = this.OAForm.District.id
				return
			}
			getodc(data).then(res => {
				if (e == 0) {
					this.Cityopiton = res.data.data
				}
				if (e == 1) {
					this.Districtopiton = res.data.data
				}
			})
		},
		getbottomnav() {
			var data = {
				page_index: 1,
				page_size: 15,
				flag:99
			}
			getbottomnav(data).then(res => {
				this.bottomnav = res.data.data.list
			})
		},
		gobottomnav(type, link) {
			if (type == 1) {
				this.$router.push({
					path: link
				});
			} else if (type == 2) {
				window.location.href = link;
			}
		},
		logout() {
			var that = this
			this.$confirm('是否确认退出登录?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$alert("已退出登录", '', {
					confirmButtonText: '确认',
					callback: action => {
						localStorage.setItem('token', '')
						localStorage.setItem('refreshToken', '')
						that.$router.go(0)
					}
				});
			}).catch(() => {

			});
		},
		showofficialQRCode() {
			this.showofficialQR = true
		},
		hideofficialQRCode() {//隐藏二维码
			this.showofficialQR = false
		},
		showserviceQRCode() {
			this.showserviceQR = true
		},
		hideserviceQRCode() {//隐藏二维码
			this.showserviceQR = false
		},
		showQRCode() {//显示二维码
			this.showQR = true
		},
		hideQRCode() {//隐藏二维码
			this.showQR = false
		},
		scrollToTop() {
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
			this.scrolltop = scrollTop
			if (parseInt(this.scrolltop) > (parseInt(this.heights) / 3)) {
				this.tops = true
			} else {
				this.tops = false
			}
		},
		gotop() {
			let timer = setInterval(() => {
				document.documentElement.scrollTop = document.body.scrollTop = this.scrolltop - 90
				if (this.scrolltop === 0) {
					clearInterval(timer)
				}
			}, 15)
		},
		bindtraveler() {
			var that = this;
			var data = {
				legal_mobile: this.ruleForm.mobile,
				captcha: this.ruleForm.captcha,
				name: this.campform.name,
				truename: this.campform.truename,
				mobile: this.campform.phone,
				pass: this.ruleForm.password,
				repass: this.ruleForm.repassword,
				id: this.travelerdata.id,
			}
			if (this.ruleForm.mobile == '') {
				this.$alert('请输入手机号，然后发送验证码', '请输入手机号', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return;
			}
			if (this.ruleForm.mobile.length != 11) {
				this.$alert('手机号长度位数错误', '手机号长度错误', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return;
			}
			if (this.ruleForm.captcha == '') {
				this.$alert('请填写验证码', '存在未填项', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return;
			}
			if (this.campform.name == '') {
				this.$alert('请填写登录账号', '存在未填项', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return;
			}
			if (this.campform.truename == '') {
				this.$alert('请填写真实姓名', '存在未填项', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return;
			}
			if (this.campform.phone == '') {
				this.$alert('请填写管理员手机号', '存在未填项', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return;
			}
			if (this.ruleForm.password == '') {
				this.$alert('请设置密码', '存在未填项', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return;
			}
			if (this.ruleForm.repassword == '') {
				this.$alert('请确认密码', '存在未填项', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return;
			}
			if (this.ruleForm.password != this.ruleForm.repassword) {
				this.$alert('登录密码和确认密码不一致', '登录密码和确认密码不一致', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return
			}
			bindtraveler(data).then(res => {
				that.$alert('机构注册管理账号成功', '注册成功', {
					confirmButtonText: '确认',
					callback: action => {
						that.next()
					}
				});
			})
		},
		searchtraveler() {
			var that = this
			var data = {
				legal_mobile: this.ruleForm.mobile,
				captcha: this.ruleForm.captcha,
			}
			if (this.ruleForm.mobile == '') {
				this.$alert('请输入手机号，然后发送验证码', '请输入手机号', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return;
			}
			if (this.ruleForm.mobile.length != 11) {
				this.$alert('手机号长度位数错误', '手机号长度错误', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return;
			}
			if (this.ruleForm.captcha == '') {
				this.$alert('请填写验证码', '存在未填项', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return;
			}
			searchtraveler(data).then(res => {
				console.log(res.data.data)
				this.travelerdata = res.data.data
				this.register_searchtype = true
			})


		},
		searchcamp() {
			var that = this
			var data = {
				legal_mobile: this.ruleForm.mobile,
				captcha: this.ruleForm.captcha,
			}
			if (this.ruleForm.mobile == '') {
				this.$alert('请输入手机号，然后发送验证码', '请输入手机号', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return;
			}
			if (this.ruleForm.mobile.length != 11) {
				this.$alert('手机号长度位数错误', '手机号长度错误', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return;
			}
			if (this.ruleForm.captcha == '') {
				this.$alert('请填写验证码', '存在未填项', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return;
			}
			searchcamp(data).then(res => {
				console.log(res.data.data)
				this.camplist = res.data.data

				this.register_searchtype = true
			})
		},
		selectcamp(e) {
			console.log(e)
			this.campmsg = e
			this.campshow = true
		},
		bindcamp(formName) {
			var that = this;
			var data = {
				legal_mobile: this.ruleForm.mobile,
				captcha: this.ruleForm.captcha,
				name: this.campform.name,
				truename: this.campform.truename,
				mobile: this.campform.phone,
				pass: this.ruleForm.password,
				repass: this.ruleForm.repassword,
				camp_id: this.campmsg.id,
			}
			if (this.ruleForm.mobile == '') {
				this.$alert('请输入手机号，然后发送验证码', '请输入手机号', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return;
			}
			if (this.ruleForm.mobile.length != 11) {
				this.$alert('手机号长度位数错误', '手机号长度错误', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return;
			}
			if (this.ruleForm.captcha == '') {
				this.$alert('请填写验证码', '存在未填项', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return;
			}
			if (this.campform.name == '') {
				this.$alert('请填写登录账号', '存在未填项', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return;
			}
			if (this.campform.truename == '') {
				this.$alert('请填写真实姓名', '存在未填项', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return;
			}
			if (this.campform.phone == '') {
				this.$alert('请填写管理员手机号', '存在未填项', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return;
			}
			if (this.ruleForm.password == '') {
				this.$alert('请设置密码', '存在未填项', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return;
			}
			if (this.ruleForm.repassword == '') {
				this.$alert('请确认密码', '存在未填项', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return;
			}
			if (this.ruleForm.password != this.ruleForm.repassword) {
				this.$alert('登录密码和确认密码不一致', '登录密码和确认密码不一致', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return
			}
			bindcamp(data).then(res => {
				that.$alert('机构注册管理账号成功', '注册成功', {
					confirmButtonText: '确认',
					callback: action => {
						that.next()
					}
				});
			})
		},
		bindmentor(formName) {
			var that = this;
			var data = {
				mobile: this.ruleForm.mobile,
				sfzh: this.mentor.sfzh,
				zsbh: this.mentor.zsbh,
				captcha: this.ruleForm.captcha,
			}
			if (this.ruleForm.mobile == '') {
				this.$alert('请输入手机号，然后发送验证码', '请输入手机号', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return;
			}
			if (this.ruleForm.mobile.length != 11) {
				this.$alert('手机号长度位数错误', '手机号长度错误', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return;
			}
			if (this.ruleForm.captcha == '') {
				this.$alert('请填写验证码', '存在未填项', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return;
			}
			if (this.mentor.sfzh == '') {
				this.$alert('请填写导师身份证号码', '存在未填项', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return;
			}
			if (this.mentor.zsbh == '') {
				this.$alert('请填写导师证书编号', '存在未填项', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return;
			}
			bindmentor(data).then(res => {
				that.$alert('小程序账号绑定导师成功', '绑定成功', {
					confirmButtonText: '确认',
					callback: action => {
						that.next()
					}
				});
			})

		},
		timer() {
			let promise = new Promise((resolve, reject) => {
				let setTimer = setInterval(
					() => {
						this.second = this.second - 1;
						if (this.second <= 0) {
							this.second = 60;
							this.send = true
							resolve(setTimer)
						}
					}
					, 1000)
			})
			promise.then((setTimer) => {
				this.CD = true;
				clearInterval(setTimer)
			})
		},
		putyzm(e) {
			var data = {
				mobile: this.ruleForm.mobile
			}
			if (this.ruleForm.mobile == '') {
				this.$alert('请输入手机号，然后发动验证码', '请输入手机号', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return;
			}
			console.log(this.ruleForm.mobile.length)
			if (this.ruleForm.mobile.length != 11) {
				this.$alert('手机号长度位数错误', '手机号长度错误', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return;
			}
			this.CD = false;
			this.timer();
			yzmsms(data).then(res => {
				console.log(res)
			})
		},
		OAregister() {
			var that = this;
			const { uname, loginName, gender, telNumber, orgDepartmentId, orgPostId, orgLevelId, pass, repass } = this.OAForm;
			var data = {
				uname,
				loginName,
				gender,
				telNumber,
				orgDepartmentId,
				orgPostId,
				orgLevelId,
				pass,
				repass,
			}
			if (data.uname == '') {
				this.$alert('请填写姓名', '存在未填项', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return
			}
			if (data.loginName == '') {
				this.$alert('请填写登录名', '存在未填项', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return
			}
			if (data.gender == '') {
				this.$alert('请选择性别', '存在未选项', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return
			}
			if (data.telNumber == '') {
				this.$alert('请填写手机号', '存在未填项', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return
			}
			if (data.orgDepartmentId === '') {
				this.$alert('请选择部门区域', '存在未选项', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return
			}
			if (data.orgPostId == '') {
				this.$alert('请选择主岗', '存在未选项', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return
			}
			if (data.orgLevelId == '') {
				this.$alert('请选择职务级别', '存在未选项', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return
			}
			if (data.pass == '') {
				this.$alert('请设置密码', '存在未填项', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return;
			}
			if (data.repass == '') {
				this.$alert('请确认密码', '存在未填项', {
					confirmButtonText: '确认',
					callback: action => {

					}
				});
				return;
			}
			data.gender = this.OAForm.gender.id
			// data.orgDepartmentId=this.OAForm.orgDepartmentId.id
			data.orgPostId = this.OAForm.orgPostId.id
			data.orgLevelId = this.OAForm.orgLevelId.id
			OAregister(data).then(res => {
				if (res.data.code == 200) {
					that.$alert('OA账号注册成功', '注册成功', {
						confirmButtonText: '确认',
						callback: action => {
							that.next()
						}
					});
				}
			})
		},
		register(formName) {
			var that = this;
			var data = this.ruleForm;
			this.$refs[formName].validate((valid) => {
				if (valid) {
					// alert('submit!');
					if (this.ruleForm.password != this.ruleForm.repassword) {
						this.$alert('登录密码和确认密码不一致', '登录密码和确认密码不一致', {
							confirmButtonText: '确认',
							callback: action => {

							}
						});
						return
					}
					if (this.agreementchecked == false) {
						this.$alert('有未同意的协议，请同意协议后重试', '请同意协议', {
							confirmButtonText: '确认',
							callback: action => {

							}
						});
						return;
					}
					register(data).then(res => {
						console.log(res)
						that.$alert('小程序账号注册成功', '注册成功', {
							confirmButtonText: '确认',
							callback: action => {
								that.next()
							}
						});
					})
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		showphonebox() {
			this.phoneboxshow = true
		},
		closephonebox() {
			this.phoneboxshow = false
		},
		gohome(e) {
			this.$router.push({
				path: "/Home",
				name: "/Home",
				query: {
				}
			});
		},
		handleRemove(file, fileList) {
			console.log(file, fileList);
		},
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url;
			this.dialogVisible = true;
		},
		register_typechange(e) {
			this.register_type = e
		},
		resetting() {
			this.stepid = 0
			this.register_searchtype = false
			this.ruleForm = {
				mobile: '',
				nickName: '',
				password: '',
				repassword: '',
				unionid: '',
				openid: '',
				captcha: '',
				is_pc: 1,
			}
			this.campmsg = {}
			this.camplist = []

		},
		next() {
			// if(this.register_type==6){
			// 	this.$alert('该功能暂未开放', '暂未开放', {
			// 		confirmButtonText: '确认',
			// 		callback: action => {

			// 		}
			// 	});
			// 	return
			// }
			if (this.stepid < 3) {
				this.stepid = this.stepid + 1
			}
		},
		showstep(ind) {
			this.$refs.carousel.setActiveItem(ind)
		},
		goplate(id) {

		},
		getPlate() {
			var data = {
				flag:99
			}
			getPlate(data).then(res => {
				this.platelist = res.data.data
			})
		},
		getlinelist() {
			var data = {
				page_index: 1,
				page_size: 4,
			}
			getLinelist(data).then(res => {
				console.log(res.data)
				this.linelist = res.data.data.list
				// this.quicklist=res.data.data.list
			}).catch(error => {
				console.error(error);
			});
		},
		getAdvbanner() {
			var data = {
				is_pc: 2,
				flag: 'A'
			}
			getAdvbanner(data).then(res => {
				console.log('getAdvbanner', res)
				this.advbanner = res.data.data
			})
		},
		changementor(e) {
			console.log('1112', e)
			this.mentorindex = e + 1
			this.getmentor()
		},
		mentoropen(index) {
			this.mentor_index = index
		},
		relist(data) {
			const list = data.split(',');
			return list
		},
		getmentor() {
			var data = {
				page_index: 1,
				page_size: 3
			}
			getTeacher(data).then(res => {
				this.mentorlist = res.data.data.list
			})
		},
		getNt() {
			var data={
				flag:99
			}
			getNt(data).then(res => {
				this.ntlist = res.data.data
			})
		},
		getpcset() {
			var data={
				flag:99
			}
			getPc(data).then(res => {
				this.pcsetdata = res.data.data
			})
		},
		golesson(e) {
			this.$router.push({
				path: "/CourseDetails",
				name: "CourseDetails",
				query: {
					id: e
				}
			});
		},
		camptypetab(val) {
			// this.lessoncategory_id=val
			this.getlessonlist()
		},
		getlessontypes() {
			var data = {}
			getPac(data).then(res => {
				console.log(res.data)
				this.categorytypes = res.data.data.cat
				// this.periodtypes=res.data.data.res
				// this.lessoncategory_id=res.data.data.cat[0].id
				this.getlessonlist()
			}).catch(error => {
				console.error(error);
			});
		},
		getlessonlist() {
			var data = {
				// type:this.camptype,
				category_id: this.lessoncategory_id,
				page_index: 1,
				page_size: 4,
			}
			getCourselist(data).then(res => {
				console.log(res.data)
				this.lessonlist = res.data.data.list
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				loading.close();
				// this.total=res.data.data.total
				// this.quicklist=res.data.data.list
			}).catch(error => {
				console.error(error);
			});
		},
		newshandleClick(e) {
			console.log(e, this.category_id)
			this._getNewslist()
		},
		getnewstypes() {
			var data = {}
			getCategory(data).then(res => {
				console.log(res.data)
				this.newstypes = res.data.data
				this.newscategory_id = res.data.data[0].id
				this._getNewslist()
			}).catch(error => {
				console.error(error);
			});
		},
		_getNewslist() {
			var data = {
				page_index: 1,
				page_size: 7,
				category_id: this.newscategory_id,
			}
			getNewslist(data).then(res => {
				console.log(res.data)
				this.newslist = res.data.data.list
			}).catch(error => {
				console.error(error);
			});
		},
		_getCamplist() {
			var data = {
				page_index: 1,
				page_size: 4
			}
			getCamplist(data).then(res => {
				console.log(res.data)
				this.Camplist = res.data.data.list
			}).catch(error => {
				console.error(error);
			});
		},
		_getAclist() {
			var data = {
				page_index: 1,
				page_size: 3
			}
			getAclist(data).then(res => {
				console.log(res.data)
				this.aclist = res.data.data.list
				// this.banner=res.data.data
			}).catch(error => {
				console.error(error);
			});
		},
		_getColumn() {
			getColumn().then(res => {
				console.log(res.data)
				// this.banner=res.data.data
			}).catch(error => {
				console.error(error);
			});
		},
		_getbanner() {
			console.log(22233, getBanner())
			var data = {
				is_pc: 2
			}
			getBanner(data).then(res => {
				console.log(res.data)
				this.banner = res.data.data
			}).catch(error => {
				console.error(error);
			});
		},
		handleSelect(key, keyPath) {
			console.log(key, keyPath);
		},
		golist(e) {
			this.$router.push({
				path: "/" + e,
				name: "/" + e,
				query: {
				}
			});
		},
		gontdetails(e) {
			this.$router.push({
				path: "/Ntdetails",
				name: "Ntdetails",
				query: {
					id: e
				}
			});
		},
		gonews(e) {
			this.$router.push({
				path: "/NewsDetails",
				name: "NewsDetails",
				query: {
					id: e
				}
			});
		},
		gocamp(e) {
			this.$router.push({
				path: "/CampDetails",
				name: "CampDetails",
				query: {
					id: e
				}
			});
		},
		goline(e) {
			this.$router.push({
				path: "/LineDetails",
				name: "LineDetails",
				query: {
					id: e
				}
			});
		},
		goactivity(e) {
			this.$router.push({
				path: "/Activitydetails",
				name: "Activitydetails",
				query: {
					id: e
				}
			});
		},
	}
};

</script>

<style scoped>
.form_msgbox {
	flex: 1;
	font-size: 14px;
}

.msgbox_item {
	width: 100%;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	color: #303133;
}

.formmsg_title {
	/* width: 110px; */
	text-align: left;

	font-weight: 600;
}

.frommsg_text {
	color: #909399;
}

.register_finality_icon {
	width: 200px;
	height: 200px;

}

.register_finality_icon img {
	width: 100%;
	height: 100%;
}

.register_finality {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

.register_finality_title {
	font-size: 24px;
	color: #333;
	font-weight: 500;
	margin-top: 30px;
}

.register_finality_subtitle {
	font-size: 18px;
	color: #666;
	margin-top: 20px;
	display: flex;
	align-items: center;
}

.register_finality_subtitle a {
	color: #FE7C2B !important;
}

.register_finality_button {
	text-align: center;
	margin-top: 50px;
}

.register_box {
	width: 1580px;
	margin: auto;
	padding: 50px 30px 30px;
	border-radius: 15px;

	padding: 40px 0;
	/* background: #e3fce9; */
}

.register_box .title {
	color: #FE7C2B;
	font-weight: 600;
	font-size: 32px;
	margin-bottom: 40px;
	text-align: center
}

.box_t {
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	margin-top: 20px;
}

.box_t img {
	width: 295px;
	height: 120px;
	margin-bottom: 18px;
}

.register_box .enter {
	width: 480px;
	height: 70px;
	line-height: 70px;
	/* text-align: center; */
	margin: 60px auto;
	background-color: #FE7C2B;
	border-radius: 30px;
	font-weight: 600;
	color: #ffffff;
	font-size: 32px;
	text-align: center
}

.enter:hover {
	cursor: pointer;
}

.msg {
	color: #918e8e;
	;
	font-size: 16px;
	width: 1580px;
	text-align: none !important;
}

.msg_unit {

	display: flex;
	text-align: none !important;
}

.news {
	margin-top: 30px;
}

.title_msg {
	width: 82px;
}

.title_msg3 {
	width: 71px;
}

.title_msg2 {
	width: 76px;
}

#msg_imp {
	text-align: left;
}

.slsicon {
	border: 1px solid #72eb62;
	color: #259117;
	background-color: #e7fee4;
}
.dialog_border  {
  border-radius: 19px !important;
}
.dia_height{
	margin-bottom: 60px;
	font-size: 15px
	
}
.divi{
	margin-top:-15px;
	width: 590px;
	margin-bottom:40px;
	margin-left:-19px;
	border-bottom: 1px solid #f6f6f6;
}
.dia_title{
	position: absolute;
	top:15px;
	left:20px;
	line-height: 19px;
	padding-left:5px;
	font-size:16px;
	border-left: 4px solid rgb(19, 184, 167);
	/* padding-bottom:10px; */
	text-align: left;
	
}
.el-icon-warning-outline{
	margin-right: 5px
}
.div_a:nth-of-type(2){
	color:black;
}
.div_a{
	margin:0 auto;
	margin-bottom:20px;
	margin-top:10px;
	width:510px;
	background-color: #f6f6f6;
	border-radius: 8px;
	height: 65px;
	padding-top:10px;
	color:black;
	border-left:4px solid rgb(19, 184, 167, 0.76);
	line-height:30px;
	font-size: 20px;
	display: flex;
	flex-direction: column;
	justify-content: space-evenly;

}

.close{
	width:140px;
	height: 40px;
	line-height:40px;
	margin: 0 auto;
	margin-top:-25px;
	background-color: rgb(19, 184, 167);
	color:#ffffff;
	border-radius: 20px;
}

a{
	color:inherit;
}
a:hover{
	color:rgb(19, 184, 167, 0.76);
}
.type_title {
	font-size: 18px;
	font-weight: 400;
	margin-block-start: 0.83em;
	/* margin-block-end: 0.83em; */
	margin-inline-start: 0px;
	margin-inline-end: 0px;
}
.pdf_msg{
	margin-top: -20px;
	margin-bottom:20px;
}

.form_tips {
	width: 350px !important;
	position: relative;
	display: flex;
	padding: 9px 0 !important;
	line-height: 20px;
	margin-right: 10px;
	color: #999 !important;
	text-align: left;
	margin-left: 10px;
}

.register_buttonbox1 {
	margin-top: 20px;
	position: relative;
	text-align: center;
	padding: 5px 0 10px;
	margin-bottom: 15px;
	clear: both;
	margin: 0;

}

.register_buttonbox1 button {
	height: 44px;
	line-height: 44px;
	padding: 0 25px;
	font-size: 16px;
}

.home_banner_text {
	width: 100%;
	padding: 4px 0;
	background: rgba(71, 86, 105, .51);
	color: #fff;
	text-align: center;
	position: absolute;
	bottom: 0;
	height: 18px;
	line-height: 18px;
	font-size: 14px;
}

body {
	background: #ffffff;
}

#appbox {
	background: #ffffff;
}

.Home_column1 {
	width: 1180px;
	display: flex;
	margin: 0 auto;
	justify-content: space-between;
	margin-top: 50px;
}

.Home_column2 {
	width: 1180px;
	margin: 0 auto;
	margin-top: 20px;
}

.column_titlebox {
	width: 100%;
	padding: 20px 0px;
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
}

.column_title {
	font-size: 22px;
	color: #FE7C2B;
}

.column_right {
	display: flex;
	align-items: flex-end;

}

.column_right:first-child {
	border-left: 0px !important;
	/* 父元素的第一个子元素的样式 */
}

.mentor_type {
	padding: 0px 10px;
	font-size: 16px;
	border-left: 1px solid #606266;
	color: #606266;
}

.gomore_mentor {
	margin-left: 20px;
	font-size: 14px;
	color: #606266;
}

.column_gomore {
	text-align: right;
	font-size: 16px;
	color: #C0C4CC;
}

.column2_box {
	width: 100%;

	display: flex;
	justify-content: space-between;
	align-items: flex-end;
}

.column_blockimg {
	width: 285px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
}

.product_box {
	width: 1180px;
	display: flex;
	align-items: center;
	justify-content: center;
	border: 1px solid #EBEEF5;
	padding: 15px 0px;
	border-radius: 5px;
	/* height: ; */
}

.prodduct_item {
	width: 195px;
	height: 60px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	border-left: 1px solid #EBEEF5;
}

.prodduct_title {
	padding: 4px 10px;
	border-radius: 10px;
	margin-bottom: 4px;
	font-size: 18px;
	font-weight: 600;
	color: #303133;
}

.product_msg {
	font-size: 14px;
	color: #909399;
}

.mentor_item {
	padding: 20px;
	width: 330px;
	display: flex;
	align-items: center;
	background: #f9f9f9;
	border-radius: 8px;
}

.mentor_imgs {
	width: 100px;
	height: 135px;
}

.mentor_imgs img {
	border-radius: 5px;
	width: 100%;
	height: 100%;
}

.mentor_msgbox {
	margin-left: 20px;
	flex: 1;
	display: flex;
	flex-direction: column;

}

.mentor_title {
	font-size: 18px;
	font-weight: 600;
	color: #303133;
	text-align: left;
}

.mentor_subtitle {
	font-size: 15px;
	color: #909399;
	margin: 10px 0px;
	text-align: left;
}

.mentor_msg {
	font-size: 12px;
	color: #909399;
	margin: 1px;
	text-align: left;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;

}

.Traveler_item {
	padding: 20px;
	width: 340px;
	background: #f9f9f9;
	border-radius: 8px;
}

.Traveler_title {
	width: 100%;
	font-size: 18px;
	color: #303133;
	text-align: left;
	margin-bottom: 10px;
}

.Traveler_msg {
	width: 100%;
	font-size: 14px;
	color: #909399;
	text-align: left;
}

.prodduct_item {}

.column2_item {
	width: 265px;
	height: 260px;
	border-radius: 15px;
	position: relative;
}

.camp_rank {
	position: absolute;
	left: 0px;
	top: 0px;
	padding: 4px 8px;
	font-size: 14px;
	border-radius: 10px 0px;
	background: #fe3113;
	color: #ffffff;
}

.column2_img {
	width: 100%;
	height: 180px;
}

.column2_img img {
	width: 100%;
	height: 100%;
	border-radius: 10px 10px 0px 0px;
}

.column2_title {
	padding: 10px;
	background: #f9f9f9;
	border-radius: 0px 0px 10px 10px;
	padding-bottom: 15px;
}

.item_title {
	font-size: 18px;
	font-weight: 600;
	color: #303133;
	margin-bottom: 15px;
	text-align: left;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	/* text-overflow: ellipsis;
		white-space: normal;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical; */
}

.item_subtitle {
	font-size: 14px;
	color: #909399;
	text-align: left;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}


.Home_imgs {
	width: 575px;

}

.newnews_box {
	width: 580px;
}

.news_top {
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
}

.news_title {
	padding: 15px;
	border-bottom: 2px solid #FE7C2B;
	color: #FE7C2B;
	font-size: 22px;
	font-weight: 600;
}

.news_gomroe {
	padding: 17px 0px;
	text-align: right;
	flex: 1;
	font-size: 16px;
	border-bottom: 1px solid #E4E7ED;
	color: #C0C4CC;
}

.newslist {
	width: 100%;
	display: flex;
	flex-direction: column;
	margin: 0px;
}

.news_item {
	text-align: left;
}


.plate_icon {
	width: 70px;
	height: 70px;
}

.plate_icon img {
	width: 100%;
	width: 100%;
}

.plate_title {
	margin-top: 10px;
}

.plate_item {
	width: 340px;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	border-left: 1px solid #ffffff;
	color: #ffffff;
	font-size: 22px;
	font-weight: 600;
}

.plate_item:hover {
	background: #cccccc38;
}

.plate_item:active {
	background: #0f6a8f36;
}

.plate_item:first-child {
	border-left: 0px solid #ffffff;
	/* 父元素的第一个子元素的样式 */
}

.plate_icon {}

.top_minemsgbox {
	width: 1230px;
	padding: 10px 0px;
	/* height: 110px; */
	display: flex;
	align-items: center;
	justify-content: flex-start;
	margin: 0 auto;
	font-size: 15px;
	color: #606266;
	/* padding: 120px; */
}

.welcome {
	color: #187192;
	font-size: 16px;
	margin: 0px 40px;
	/* flex: 1; */
	text-align: left;
	margin-right: 200px;

}

.top_right {
	display: flex;
	align-items: center;
}

.top_Mobiletype {
	padding: 4px 15px;
	background: #FE7C2B;
	color: #ffffff;
	border-radius: 20px;
	margin-right: 10px;
	font-size: 14px;
}

.top_box {
	width: 1230px !important;
	justify-content: flex-start;
}

.logo_box {
	margin-right: 80px;
}

.top_gatebox {
	margin-right: 300px;
}

.top_search_box {
	display: flex;
	align-items: center;
}

.top_search {
	display: flex;
	align-items: center;
	border: 1.5px solid #FE7C2B;
	position: relative;
	padding: 6px 20px;
	border-radius: 60px;
	margin: 0px 20px;
	font-size: 16px;
}

.top_search input {
	width: 300px;
	color: #747dce;
}

.top_search i {
	font-size: 20px;
	font-weight: 600;
	color: #C0C4CC;
}

.top_search_icon {
	width: 64px !important;
	height: 64px !important;
	object-fit: contain;
	position: absolute;
	right: -10px;
}

.toptabnav {
	height: 70px !important;
	/* 	background: #FE7C2B00;
		position: absolute; */
	z-index: 99;
}

.top_tab_box {
	width: 100%;
	position: relative;
}

.top_banner {}

.top_plate {
	/* position: absolute; */
	/* bottom: 0px; */
	width: 100%;
	height: 164px;
	display: flex;
	justify-content: center;
	background: #FE7C2B;
	z-index: 99;
}



.el-tag--mini {
	font-size: 8px !important;
	padding: 0 2.8px;
}

.mentor {
	width: 1100px;
	margin: 0 auto;
	margin-top: 20px;

}

.mentor_box {
	width: 1100px;
	display: flex;
	/* justify-content: ; */
	flex-wrap: wrap;

	background: #30313336;
}

.mentor_msg_box {
	position: absolute;
	width: 180px;
	height: 245px;
	background: #333333c7;
	color: #ffffff;
	top: 0px;
	left: 0px;
}

/* 	.mentor_title{
		padding:15px 10px;
		margin: 0px 10px;
		margin-top: 50px;
		font-size: 20px;
		font-weight: 500;
		border-bottom: 1px solid #ffffff;
	} */
.mentor_tags {
	padding: 9px;
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	justify-content: space-between;
}

.mentor_camp {
	font-size: 14px;
	text-align: left;
	padding: 10px;
	padding-top: 0px;
}

.ntmain {
	width: 1000px;
}

.nttext:hover {
	color: #FE7C2B !important;
}

.ntbox {
	width: 1060px;
	background: #ffffff;
	margin: 10px auto;
	display: flex;
	align-items: center;
	padding: 0px 20px;
}

.nticon {
	width: 30px;
	height: 30px;
	margin-right: 10px;
}

.el-carousel__item h3 {
	opacity: 1 !important;
}

.lessonbox {
	width: 1100px;
	margin: 0 auto;
	margin-top: 20px;
}

.home_titlebox {
	width: 1100px;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.next_text {
	margin-bottom: 20px;
	font-size: 16px;
}

.camplist {
	padding: 20px;
	width: 1060px;
	background: #ffffff;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: center;
}

.lessonlist {
	padding: 20px;
	width: 1060px;
	background: #ffffff;
	flex-wrap: wrap;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.actlist {
	padding: 20px;
	width: 1060px;
	background: #ffffff;
	flex-wrap: wrap;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.actmsgbox {
	width: 320px;
	padding: 10px;
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
}

.actbutton {
	width: 80px;
	height: 30px;
	line-height: 30px;
	font-size: 18px;
	color: #ffffff;
	background: #FE7C2B;
}

.actbutton2 {
	width: 80px;
	height: 30px;
	line-height: 30px;
	font-size: 18px;
	color: #ffffff;
	background: #9e9e9e;
}

.actbox {
	width: 1100px;
	margin-top: 20px !important;
	margin: 0 auto;
}

.campitem {
	width: 340px;
	border-radius: 8px;
	color: #333;
}

.lessonitem {
	width: 257px;
	margin-bottom: 10px;
	color: #333;
}

.lessonitem:hover {
	color: #FE7C2B;
}

.campitem:hover {
	color: #FE7C2B;
}

.lessonimgbox {
	width: 257px;
	height: 177px;
	position: relative;
}

.lessonimgbox img {
	width: 100%;
	height: 100%;
}

.campimgbox {
	width: 340px;
	height: 168px;
	position: relative;

}

.actimgbox {
	width: 340px;
	height: 218px;
}

.actimgbox img {
	width: 100%;
	height: 100%;
}

.actpay {
	font-size: 14px;
	color: brown;
}

 .campimgbox img {
	width: 100%;
	height: 100%;
	border-radius: 8px 8px 0px 0px;
}

.campaddress {
	width: 320px;
	position: absolute;
	bottom: 0;
	right: 0;
	z-index: 1;
	display: flex;
	justify-content: flex-end;
	align-items: flex-end;
	font-size: 12px;
	font-weight: 600;
	color: #ffffff;
	height: 26px;
	line-height: 26px;
	padding: 0 10px;
	background: #30313336;
}

.camptitle {
	padding: 10px;
	font-size: 18px;
	width: 320px;
	height: 46px;

	/* margin-bottom: 15px; */
	text-align: left;
	/* height: 50px; */
	/* line-height: 50px; */
	text-overflow: ellipsis;
	white-space: normal;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
}

.lessontitle {
	padding: 10px;
	font-size: 18px;
	width: 237px;
	height: 46px;
	text-align: left;
	text-overflow: ellipsis;
	white-space: normal;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
}

.imgsbox {
	/* width:1100px; */
	/* margin: 10px auto; */
}

.advbanner {
	width: 1100px;
	margin: 0px auto;
}

.newsimgH {
	width: 210px;
	height: 135px;
	background-color: #333;
}

.newsitemH {
	width: 525px;
	padding: 10px;
	border-radius: 8px;
	display: flex;
	/* justify-content: ; */

	align-items: center;
	margin-bottom: 10px;
	background: #ffffff;
}

.newsitemH:hover {
	color: #FE7C2B;
}

.newsitembox {
	width: 100%;
	margin-top: 10px;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: center;
}

.newsmsgH {
	width: 280px;
	height: 135px;
	margin-left: 20px;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: space-between;
}

.news_bottomH {
	width: 100%;
	display: flex;
	justify-content: space-between;
}

.newstitle {
	font-size: 18px;

}

.campbox {
	width: 1100px;
	margin: 0 auto;
}

::v-deep .el-tabs__header {
	margin: 0px !important;
}

::v-deep .el-tabs__item {
	font-size: 18px;
	height: 78px !important;
	line-height: 78px !important;
	/* padding:30px ; */
}

::v-deep .el-select>.el-input {
	width: 360px !important;
}

::v-deep .department_select .el-select>.el-input {
	width: 200px !important;
}

.department_select {
	width: 630px;
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;
}

/* 	.el-tabs__content{
		background: #f5f5f5;
	} */
</style>

<style>
.el-form-item__content {
	display: flex;
	align-items: center;
}

.el-form-item__content>.el-input {
	/* width: 350px !important; */
	flex: 1;
}

.el-form-item__content>.el-input {
	/* width: 350px !important; */
	flex: 1;
}
</style>